export default __webpack_public_path__ + "static/media/blog05.2a6335b2.png";